import React from 'react';
import { Stack, Text, Title } from 'library/ui';

export function PayHeader({ editing }: { editing?: boolean }) {
    return (
        <Stack gap="sm">
            {!editing && <Title size="h2">Tell us how much you&apos;d pay for these credentials and beyond.</Title>}
            <Text weight="bold">Set your pay scale below.</Text>
        </Stack>
    );
}
